/**
 * Register Page
 *
 * @author edmsamuel
 */
import React from 'react'
import { connect } from 'react-redux'
import { Divider } from 'antd'
import { Redirect } from 'react-router'
import { push } from 'react-router-redux'
import Registro from '../components/Registro'
import { FLAG_LOCAL_STORAGE_TOKEN } from '../Flags'
import Api from '../Api'
import { OrgConsumer } from '../context/Organizacion'
import { buildPath } from '../Routes'

class Page extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props)
    this.onRegisterOk = this.onRegisterOk.bind(this)
  }

  /**
   * OnRegisterOk
   *
   * @param {Object} proveedor
   */
  onRegisterOk(proveedor) {
    // TODO: Registro de proveedor | localStorage.setItem(FLAG_LOCAL_STORAGE_TOKEN, proveedor.iId)
    this.props.goToNext()
  }

  /**
   * Render
   */
  render() {
    const { theme } = this.props
    if (localStorage.getItem(FLAG_LOCAL_STORAGE_TOKEN) != null) {
      return <Redirect to='/' />
    }

    return (
      <OrgConsumer>
        {org => (
          <div className='administrar clear container secondary'>
            <div className={`content clear left right bottom padded ${this.props.mode}`} style={styles.content}>
              <div style={{ ...styles.form, ...theme.styles.panel }}>
                <h3 style={styles.header}>
                  <img src={Api.to('/cmr/organizacion/image-file/imagen')} alt='app' height={35} />
                  <Divider type='vertical' />
                  <span style={{ color: theme.colors.text }}>{org.nombre}</span>
                </h3>
                <Registro onRegisterOk={this.onRegisterOk} />
              </div>
            </div>
          </div>
        )}
      </OrgConsumer>
    )
  }
}

const styles = {
  content: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  form: {
    maxWidth: 800,
    maxHeight: 700,
  },
  header: {
    marginBottom: 20
  }
}

export default connect(
  state => ({
    theme: state.theme.values,
  }),
  dispatch => ({
    goToNext: () => dispatch(push(buildPath('/'))),
  })
)(Page)
